import { render, staticRenderFns } from "./RelatedResourceRemove.vue?vue&type=template&id=a3e7deb0&"
import script from "./RelatedResourceRemove.vue?vue&type=script&lang=js&"
export * from "./RelatedResourceRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports